import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import LoadingOverlay from "../../components/loadingOverlay";
import { API_BASE } from "../../config/apiConfig";
import { FaUserCircle } from "react-icons/fa";
import { useSelector, useDispatch } from "react-redux";
import { setPlayers } from "../../features/coachPlayers/coachPlayersSlice";
import PageHeader from "../../components/pageHeader";
import MiniNavigationTabs from "./miniNavigationTabs";
import MainContentLayout from "../../components/mainContentLayout";

export default function AdminPTLogsPage() {
  const token = sessionStorage.getItem("access_token");
  const players = useSelector((state) => state.coachPlayers.players);
  const dispatch = useDispatch();
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    async function fetchPlayers() {
      if (players && players.length > 0) return;

      setLoading(true);
      try {
        const res = await fetch(`${API_BASE}/api/pt-players-list`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const data = await res.json();
        if (data.success) {
          const sorted = data.players.sort((a, b) =>
            a.fullName.localeCompare(b.fullName)
          );
          dispatch(setPlayers(sorted));
        }
      } finally {
        setLoading(false);
      }
    }

    fetchPlayers();
  }, []);

  // filter list by search
  const filteredPlayers = players.filter(
    (p) =>
      p.fullName?.toLowerCase().includes(search.toLowerCase()) ||
      p.username?.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <MainContentLayout>
      <LoadingOverlay show={loading} />
      <PageHeader title="1 to 1 Training Logs" backTo="/dashboard" />
      <MiniNavigationTabs />

      {/* Search bar */}
      <div className="mb-6">
        <input
          type="text"
          placeholder="Search players..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="border px-3 py-2 rounded w-full md:w-1/2 placeholder:italic placeholder:text-gray-400"
        />
      </div>

      {filteredPlayers.length === 0 ? (
        <p>No players found.</p>
      ) : (
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-6">
          {filteredPlayers.map((player) => (
            <div
              key={player.user_id}
              onClick={() => navigate(`/pt-logs-list/${player.user_id}`)}
              className="cursor-pointer bg-white border rounded-xl shadow-md p-4 flex flex-col items-center hover:shadow-lg transition"
            >
              {player.photo ? (
                <img
                  src={player.photo}
                  alt="Avatar"
                  className="w-20 h-20 rounded-full border object-cover mb-2"
                />
              ) : (
                <FaUserCircle className="w-20 h-20 text-gray-400 mb-2" />
              )}
              <p className="text-center font-medium">{player.fullName}</p>
            </div>
          ))}
        </div>
      )}
    </MainContentLayout>
  );
}
